module.exports = __webpack_public_path__ + "img/phone9.533de783.png";